import { useState } from 'react';
import { SortBy, SortOption } from 'types/domain/search';
import { SelectList } from '../SelectList';
import { useAppSelector } from 'core/store/hooks';
import { selectPortrait } from 'core/selectors/product/portrait';
import { RootState } from 'types';

export function Sort({
  className,
  onSort,
  options,
}: {
  className: string;
  onSort: (val) => {};
  options?: SortOption[];
}) {
  const sort = useAppSelector((state:RootState) => state.core.search.sort);
  const portrait = useAppSelector(selectPortrait);

  const onChange = val => {
    onSort(val);
  };

  const sortOptions = options || [
    { name: 'Name', value: SortBy.NAME },
    { name: 'Date', value: SortBy.MODIFIED },
  ];

  return (
    <SelectList
      labelClassName="flex w-auto"
      listClassName=''
      className={className}
      label={portrait ? '' : 'Sort'}
      value={sort}
      items={sortOptions}
      onChange={onChange}
    />
  );
}
